import {
  DeviceAlertComparisonType,
  DeviceAlertMetricName,
  MetricUnit,
} from '@/__generated__/graphql';
import { ALERT_MINIMUM_INTERVALS } from '@/constants/alerts';
import { z } from 'zod';


const alertStateSchema = (delay: number) => {
  const stateSchema = z.object({
    comparisonType: z.nativeEnum(DeviceAlertComparisonType),
    eventName: z.string().optional(),
    thresholdValue: z.number().optional().nullable(),
    thresholdMax: z.number().optional().nullable(),
    thresholdMin: z.number().optional().nullable(),
    notificationDelaySec: z.number().int().min(delay).nonnegative(),
    enabled: z.boolean(),
  })
  return stateSchema;
};

export const UpdateAlertConfigurationInputSchema = z.object({
  unit: z.nativeEnum(MetricUnit),
  deviceId: z.string(),
  metric: z.nativeEnum(DeviceAlertMetricName),
  ok: alertStateSchema(ALERT_MINIMUM_INTERVALS.ok).optional(),
  warning: alertStateSchema(ALERT_MINIMUM_INTERVALS.warning).optional(),
  critical: alertStateSchema(ALERT_MINIMUM_INTERVALS.critical).optional(),
});

export const UpdateAlertConfigurationSchema = z.object({
  input: UpdateAlertConfigurationInputSchema,
});

export type FormValues = z.infer<typeof UpdateAlertConfigurationInputSchema>;
